import { createStyleSheet } from 'Components/foundation/stylesheets';
import { ANIMATIONS } from 'Components/foundation';

export type AlertStyleName = 'alert_inital' | 'alert_final';

const styles = createStyleSheet({
  // SAlert component animation [alert_inital, alert_final] 
  alert_inital: {
    position: 'fixed',
    top: 0,
    left: window.innerWidth - 4,
    transform: 'translateX(-100%)',
    transition: `all ${ANIMATIONS.SPEED.SLOW} ${ANIMATIONS.EASING.STANDARD}`,
  },
  alert_final: {
    position: 'fixed',
    top: 100,
    left: window.innerWidth - 4,
    transform: 'translateX(-100%)',
    transition: `all ${ANIMATIONS.SPEED.SLOW} ${ANIMATIONS.EASING.STANDARD}`,
  },
});

export default styles;
